import React from 'react';
import { BellIcon, ChevronDownIcon, FrameIcon, HandIcon, MessageCircleIcon, MinusIcon, MousePointer2Icon, PanelLeftIcon, PlusIcon, SquareFunctionIcon, Table2Icon } from 'lucide-react';
export type PencilTool = 'select' | 'hand' | 'comment' | 'section' | 'add';
const panel = 'rounded-xl border border-[#E0E0E0] bg-white shadow-[0_4px_8px_rgba(18,19,20,0.04)]';
export function TopLeftBar() {
  return <div className={`${panel} absolute left-3 top-3 z-20 flex h-12 items-center gap-2 px-3`} data-id="element-198" data-mp="1k08fkoupvvjx">
      <PanelLeftIcon size={20} strokeWidth={1.6} className="text-ink" data-id="element-199" data-mp="1fzg37mqjtajf" />
      <span className="h-12 w-px bg-[#EBEBEB]" data-id="element-200" data-mp="1tyfkg9bqen5k" />
      <span className="flex items-center gap-2 pl-1" data-id="element-201" data-mp="1tz7br7yapyq1">
        <SquareFunctionIcon size={18} className="text-[#E46911]" strokeWidth={2} data-id="element-202" data-mp="1oyjngu1gbvzi" />
        <span className="text-[14px] font-medium leading-5 text-ink" data-id="element-203" data-mp="35ct575b6umhd">Hoka’s Speedgoat</span>
        <ChevronDownIcon size={16} className="text-ink" data-id="element-204" data-mp="30e8bzpuct32f" />
      </span>
    </div>;
}
export function TopRightBar() {
  return <div className={`${panel} absolute right-3 top-3 z-20 flex h-12 w-[222px] items-center justify-end gap-3 p-2`} data-id="element-205" data-mp="35s6c3gdr8i5l">
      <div className="flex -space-x-1" data-id="element-206" data-mp="3aqpy1gscltxy">
        {['DO', 'AS', 'BP'].map(i => <span key={i} className="grid h-8 w-8 place-items-center rounded-full border border-white bg-[#E0E0E0] text-[13px] font-medium text-[#191915]" data-id="element-207" data-mp="3fsfcl6es4pqs">
            {i}
          </span>)}
      </div>
      <span className="relative grid h-8 w-8 place-items-center" data-id="element-208" data-mp="2n41aofkkl99y">
        <BellIcon size={19} className="text-[#191915]" fill="#191915" data-id="element-209" data-mp="2s19vknx3rrew" />
        <span className="absolute right-0 top-0 grid h-4 min-w-[15px] place-items-center rounded-full border-[1.5px] border-white bg-ink text-[10px] leading-none text-white" data-id="element-210" data-mp="2rzglszr70r2o">
          5
        </span>
      </span>
      <span className="flex h-8 items-center rounded bg-ink px-3 text-[14px] font-medium text-white" data-id="element-211" data-mp="24cgwiil6p3g2">Share</span>
    </div>;
}
const tools: {
  key: PencilTool;
  Icon: typeof HandIcon;
}[] = [{
  key: 'select',
  Icon: MousePointer2Icon
}, {
  key: 'hand',
  Icon: HandIcon
}, {
  key: 'comment',
  Icon: MessageCircleIcon
}, {
  key: 'section',
  Icon: FrameIcon
}, {
  key: 'add',
  Icon: PlusIcon
}];
export function BottomDock({
  tool
}: {
  tool: PencilTool;
}) {
  return <div className={`${panel} absolute bottom-3 left-1/2 z-20 flex h-12 -translate-x-1/2 items-center px-2`} data-id="element-212" data-mp="2b2i5pli3vipe">
      <div className="flex items-center gap-1" data-id="element-213" data-mp="263orfquzvno6">
        {tools.map(({
        key,
        Icon
      }) => <span key={key} className={`grid h-8 w-8 place-items-center rounded ${key === tool ? 'bg-ink text-white' : 'text-ink'}`} data-id="element-214" data-mp="1idugjeu8k96k">
            <Icon size={18} strokeWidth={1.8} data-id="element-215" data-mp="1s9ny5cmtasv7" />
          </span>)}
      </div>
      <span className="mx-2 h-12 w-px bg-[#EBEBEB]" data-id="element-216" data-mp="1naunrt2tnhz9" />
      <div className="flex h-8 items-center rounded-full border border-[#E0E0E0] bg-[#F5F5F5] p-0.5" data-id="element-217" data-mp="1n99qvwt1bmy8">
        <span className="grid h-7 w-9 place-items-center rounded-full border border-[#EBEBEB] bg-white" data-id="element-218" data-mp="33njh6wgu7lrp">
          <SquareFunctionIcon size={16} className="text-ink" data-id="element-219" data-mp="2ypqam2bmgpqw" />
        </span>
        <span className="grid h-7 w-9 place-items-center" data-id="element-220" data-mp="368hj2lmitm1p">
          <Table2Icon size={16} className="text-ink" data-id="element-221" data-mp="3b8c6gf737ti0" />
        </span>
      </div>
    </div>;
}
export function ZoomControl({
  scale
}: {
  scale: number;
}) {
  return <div className={`${panel} absolute bottom-4 right-3 z-20 flex h-10 w-[116px] items-center justify-between p-1`} data-id="element-222" data-mp="2xannxe0hsyg4">
      <span className="grid h-8 w-8 place-items-center" data-id="element-223" data-mp="31c92r4wl7msy">
        <MinusIcon size={18} className="text-ink" data-id="element-224" data-mp="3p1bjmajedbme" />
      </span>
      <span className="text-[14px] font-medium tabular-nums text-[#191915]" data-id="element-225" data-mp="3tzmveqt95w79">{Math.round(scale * 100)}%</span>
      <span className="grid h-8 w-8 place-items-center" data-id="element-226" data-mp="3g8i3kaw4m87h">
        <PlusIcon size={18} className="text-ink" data-id="element-227" data-mp="3g5vvma5bpqoq" />
      </span>
    </div>;
}